import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { MusteriEditComponent } from './musteri-edit.component';
import { MusteriKartComponent } from './musteri-kart.component';
import { MusteriKartSadeComponent } from './musteri-kart-sade.component';

@DinamikBilesen({
  id: 'musteri',
  baslik: 'Müşteri',
  aciklama: 'Müşteri kaydı',
  ikon: 'team',
  kategori: 'satis',
})
class Musteri {
  paylas_kutusu = MusteriEditComponent;
  paylasilmis_kart = MusteriKartComponent;
  paylasilmis_kart_sade = MusteriKartSadeComponent;
}
